import { ContentPage } from '@/components/content-page'
import { AdminUsers } from '@/components/admin-users'
import { AdminForumReports } from '@/components/admin-forum'

export default function AdminPage() {
  return (
    <ContentPage
      eyebrow="// admin"
      title="Community administration"
      description="Manage registered users, forum badges, and member reports."
    >
      <div className="flex flex-col gap-6">
        <AdminUsers />
        <AdminForumReports />
      </div>
    </ContentPage>
  )
}
